<ng-container>
  <!-- 
  ============ Things to consider ==============
  1. This component has to take care of switching between the visa or nqr qr codes.
  2. 
  
  -->
  <!-- Tab header -->
  <!-- <div class="zp:mb-6">
    <ul class="zp:grid zp:grid-cols-1 zp:lg:grid-cols-2 zp:gap-x-3.5">
      @for(item of qrProviders; track item) {
      <li
        (click)="updateSelection(item)"
        class="zp:flex zp:items-center zp:border zp:rounded-lg zp:p-2 zp:cursor-pointer"
        [ngClass]="{
          'zp:border-ZTG-500': item.isActive,
          'zp:border-ZTN-300': !item.isActive
        }"
      >
        <div class="zp:pr-2">
          <svg-icon [name]="item.icon" svgClass="img-fluid w-30"></svg-icon>
        </div>
        <div class="zp:text-ZTN-900 zp:text-sm">
          <p class="zp:font-medium">{{ item.title }}</p>
          <p class="zp:text-xs zp:font-normal zp:text-ZTN-500">
            {{ item.subtitle }}
          </p>
        </div>
      </li>
      }
    </ul>
  </div> -->

  <!-- tab content [activeTab]="activePaymentTab"
        (onComplete)="paymentCompleted($event)" -->
  <div>
    @if (checkProvider("nqr")) {
      <ng-container>
        <nibss-qr-channel></nibss-qr-channel>
      </ng-container>
    }
  </div>
</ng-container>
